import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user_id: '',
    user_name: '',
    authority: '',
    group_id: '',
    user_group: ''
  },
  getters: {
    getUserId: (state) => {
      return state.user_id;
    },
    getUserName: (state) => {
      return state.user_name;
    },
    getAuthority: (state) => {
      return state.authority;
    },
    getGroupId: (state) => {
      return state.group_id;
    },
    getUserGroup: (state) => {
      return state.user_group;
    },
  },
  mutations: {
    setUserId: (state, payload) => {
      state.user_id = payload;
    },
    setUserName: (state, payload) => {
      state.user_name = payload;
    },
    setAuthority: (state, payload) => {
      state.authority = payload;
    },
    setGroupId: (state, payload) => {
      state.group_id = payload;
    },
    setUserGroup: (state, payload) => {
      state.user_group = payload;
    },
  },
  actions: {}
})
